// FROM https://bootsnipp.com/snippets/DOXy4

import {useState} from 'react';
import Modal from 'react-modal';
import { useLocalisationService } from "providers/LocalisationProvider";
import { useModalScrollLock } from 'hooks/useModalScrollLock';

export const FileUploadModal = ({onSelectedFiles, isOpen, onClose, messageKey}) => {

    useModalScrollLock(isOpen);
    const [requestInFlight, setRequestInFlight] = useState(false);
    const l = useLocalisationService();

    const renderUploadDialogue = () => {
        return (
            <Modal
                className="modal file-picker-modal"
                overlayClassName="modal-overlay file-picker-modal-overlay"
                isOpen={isOpen}
                onRequestClose={onClose}
                contentLabel="File Picker Modal"
            >
            {renderUploadMessage()}
            {renderFilePicker()}
            </Modal>
        );
    }

    const renderInFlightDialogue = () => {
        return <Modal
        className="modal create-profile-modal"
        overlayClassName="modal-overlay create-profile-modal-overlay"
        isOpen={isOpen}
        onRequestClose={onClose}
        contentLabel="Create Profile">
            <div className="flexbox centered full-height">
                {l.getString('profile_create_in_flight_multiple')}
            </div>
        </Modal>;
    }

    const renderFilePicker = () => {
        return (
        <div className="row">
            <div className="col-md-6">
                <form method="post" action="#" id="#" onSubmit={(e)=>e.preventDefault()}>
                    <div className="form-group files flexbox centered">
                        <label>Upload Your File </label>
                        <input type="file" name="file" onChange={onFileChange}/>  
                    </div>  
                </form>        
            </div>
        </div>
        );
    }

    const renderUploadMessage = () => {
        const messageString = l.getStringOrNull(messageKey);
        if(!messageKey){
            return <div/>;
        }
        return <p className='centered'>{messageString}</p>
    }

    const onFileChange = (event) => {
        setRequestInFlight(true);
        onSelectedFiles(Array.from(event.target.files))
        .then(() => {
            setRequestInFlight(false);
            onClose();
        })
    }

    if(requestInFlight){
        return renderInFlightDialogue();
    }
    else{
        return renderUploadDialogue();
    }
}